// extracted by mini-css-extract-plugin
export default {"createLessonBtn":"CreateNewLessonBtn_createLessonBtn__Yw6s+","modalHeader":"CreateNewLessonBtn_modalHeader__dCDIf"};